// extracted by mini-css-extract-plugin
module.exports = {"button":"search-icon__button3hD","image":"search-icon__image1eX"};